"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Expando = void 0;
const object_1 = require("./object");
class Expando {
    constructor() {
        this.dynObj = Object.create({});
    }
    assign(other) {
        Object.assign(this.dynObj, other);
    }
    field(key, value, readonly) {
        object_1.ObjectUtils.defineField(this.dynObj, key, { value, writable: readonly !== true });
    }
    accessor(key, accessor) {
        var _a, _b;
        object_1.ObjectUtils.defineAccessor(this.dynObj, key, {
            get: (_a = accessor.get) === null || _a === void 0 ? void 0 : _a.bind(this.dynObj),
            set: (_b = accessor.set) === null || _b === void 0 ? void 0 : _b.bind(this.dynObj),
        });
    }
    method(key, func) {
        this.field(key, func.bind(this.dynObj), true);
    }
    remove(key) {
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this.dynObj[key];
    }
    toObject() {
        return this.dynObj;
    }
}
exports.Expando = Expando;
//# sourceMappingURL=expando.js.map